import { Trigger, TriggerType } from '@keyvue/one-api-client';
import IconRealworks from '@/flow/flow/assets/icons/custom-types/realworks.svg?component';

export function flowIcon(firstTrigger: Trigger) {
    switch (firstTrigger.type.value) {
        case TriggerType.REALWORKS_AGENDA.value:
        case TriggerType.REALWORKS_BIRTHDAY.value:
        case TriggerType.REALWORKS_KENMERK.value:
        case TriggerType.REALWORKS_RELATIE.value:
        case TriggerType.REALWORKS_TAAK.value:
            return IconRealworks;

        default:
            return IconRealworks;
    }
}

export function flowDescription(firstTrigger: Trigger) {
    switch (firstTrigger.type.value) {
        case TriggerType.REALWORKS_AGENDA.value: return realworksAgendaTriggerDescription(firstTrigger);
        case TriggerType.REALWORKS_BIRTHDAY.value: return realworksBirthdayTriggerDescription(firstTrigger);
        case TriggerType.REALWORKS_KENMERK.value: return realworksKenmerkTriggerDescription(firstTrigger);
        case TriggerType.REALWORKS_RELATIE.value: return realworksRelatieTriggerDescription(firstTrigger);
        case TriggerType.REALWORKS_TAAK.value: return realworksTaakTriggerDescription(firstTrigger);
        default: return 'Deze flow heeft nog geen startpunt';
    }
}

export function realworksAgendaTriggerDescription(trigger: Trigger) {
    let timing = 'op de dag van';
    if (trigger.options.timingType !== 'on') {
        const timingUnit = translateTimingUnit(trigger.options.timingUnit, trigger.options.timingQuantity);
        const timingType = translateTimingType(trigger.options.timingType);

        timing = `${trigger.options.timingQuantity} ${timingUnit} ${timingType}`;
    }

    const agendaTypes = trigger.options.agendaTypes.join('", "');

    return `Flow start ${timing} een afspraak van het type "${agendaTypes}"`;
}

export function realworksBirthdayTriggerDescription(trigger: Trigger) {
    let timing = 'op';
    if (trigger.options.timingType !== 'on') {
        const timingUnit = translateTimingUnit(trigger.options.timingUnit, trigger.options.timingQuantity);
        const timingType = translateTimingType(trigger.options.timingType);

        timing = `${trigger.options.timingQuantity} ${timingUnit} ${timingType}`;
    }

    return `Flow start ${timing} de verjaardag van een relatie`;
}

export function realworksKenmerkTriggerDescription(trigger: Trigger) {
    const kenmerken = trigger.options.kenmerken.join('", "'); // @todo replace with label when labels are available in options

    return `Flow start als een relatie het kenmerk "${kenmerken}" krijgt`;
}

export function realworksRelatieTriggerDescription(trigger: Trigger) {
    return `Flow start als het type van een relatie wijzigt naar "${trigger.options.relatietype}"`;
}

export function realworksTaakTriggerDescription(trigger: Trigger) {
    let timing = 'op de dag van';
    if (trigger.options.timingType !== 'on') {
        const timingUnit = translateTimingUnit(trigger.options.timingUnit, trigger.options.timingQuantity);
        const timingType = translateTimingType(trigger.options.timingType);

        timing = `${trigger.options.timingQuantity} ${timingUnit} ${timingType}`;
    }

    return `Flow start ${timing} een taak van het type "${trigger.options.taakType}"`;
}

export function translateTimingUnit(timingUnit: string, timingQuantity: string | number) {
    const timingQuantityNumber = Number.parseInt(timingQuantity.toString(), 10);

    switch (timingUnit) {
        case 'seconds': return timingQuantityNumber === 1 ? 'seconde' : 'seconden';
        case 'minutes': return timingQuantityNumber === 1 ? 'minuut' : 'minuten';
        case 'hours': return timingQuantityNumber === 1 ? 'uur' : 'uren';
        case 'days': return timingQuantityNumber === 1 ? 'dag' : 'dagen';
        case 'weeks': return timingQuantityNumber === 1 ? 'week' : 'weken';
        case 'months': return timingQuantityNumber === 1 ? 'maand' : 'maanden';
        case 'years': return timingQuantityNumber === 1 ? 'jaar' : 'jaren';
        default: return timingUnit;
    }
}

function translateTimingType(timingType: string) {
    switch (timingType) {
        case 'before': return 'voor';
        case 'after': return 'na';
        case 'on': return 'op';
        default: return timingType;
    }
}
